import { z } from "zod";

const Coordinate = z.object({
  companyCode: z.string(),
  divisionCode: z.string(),
  productCode: z.string(),
});
export const FiarSetupCatalogSchema = z.object({
  scenario_id: z.string().uuid(),
  target_year: z.number().int(),
  copy_forward_years: z.array(z.number().int()),
  products: z.array(
    Coordinate.extend({ label: z.string(), source_months: z.array(z.string()).default([]) }),
  ),
  unsupported_companies: z.array(z.string()),
});
export const FiarSetupResultSchema = z.object({
  status: z.enum(["QUEUED", "RUNNING", "LOADED", "PRESERVED", "REPAIRED", "NEEDS_REVIEW"]),
  coordinate: Coordinate,
  warning: z.string().optional(),
  job_id: z.string().optional(),
  missing_months: z.array(z.string()).optional(),
});
export type FiarSetupCatalog = z.infer<typeof FiarSetupCatalogSchema>;
export type FiarSetupResult = z.infer<typeof FiarSetupResultSchema>;
export interface FiarSetupRates {
  readonly renewalRate: number;
  readonly grossCommissionRate: number;
  readonly wholesaleAuditRate: number;
  readonly wholesaleFeeRate: number;
  readonly fallbackQuoteRate: number;
  readonly fallbackHitRate: number;
}
